import { gsap } from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import Alpine from "alpinejs";

gsap.registerPlugin(DrawSVGPlugin);

/**
 * Set on <html> as soon as the intro starts. Lifts the CSS pre-hide (stage.scss, only active
 * while body has "has-stage-intro" from StageHelper.php) and, because <html> survives barba page
 * transitions, also marks that the nav has already been animated in.
 */
const INTRO_STARTED_CLASS = "stage-intro-started";

Alpine.data("stage", () => ({
  timeline: null as gsap.core.Timeline | null,

  init() {
    const root = document.documentElement;
    const isFirstPageLoad = !root.classList.contains(INTRO_STARTED_CLASS);

    root.classList.add(INTRO_STARTED_CLASS);

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const q = gsap.utils.selector(this.$root);
    const nav = document.querySelector(".c-nav__container");

    const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

    // 1. nav slides in from the top (first page load only, it persists across barba transitions)
    if (isFirstPageLoad && nav) {
      tl.from(nav, { yPercent: -120, opacity: 0, duration: 0.9, clearProps: "transform,opacity" }, 0);
    }

    // 2. headline line by line
    tl.from(
      q(".c-stage__line"),
      { yPercent: 60, opacity: 0, duration: 1, stagger: 0.15, clearProps: "transform,opacity" },
      0.2
    );

    // 3. images pop in
    tl.from(
      q(".c-stage__image"),
      { scale: 0.6, opacity: 0, duration: 0.8, stagger: 0.15, ease: "back.out(1.6)", clearProps: "transform,opacity" },
      0.6
    );

    // 4. scribbles get drawn like a pen stroke, alongside the headline rather than after it
    //    (so they read as decoration, not as the main event)
    tl.from(
      q(".c-stage__drawing path"),
      // slow + even pen speed so it feels hand-drawn, not hectic; starts early so it doesn't lag
      { drawSVG: "0%", duration: 1.6, stagger: 0.2, ease: "sine.inOut" },
      0.3
    );

    // 5. intro text + scroll link
    tl.from(
      q(".c-stage__footer > *"),
      { y: 20, opacity: 0, duration: 0.8, stagger: 0.1, clearProps: "transform,opacity" },
      1.1
    );

    this.timeline = tl;
  },

  destroy() {
    this.timeline?.kill();
  },
}));
